import {StyleSheet} from "aphrodite";
import type {ReactNode} from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Checkbox} from "@khanacademy/wonder-blocks-form";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {useFlagOrCookie} from "@khan/analytics-growthbook";

import {SignUpLegalCheckboxBlurb} from "./legal-blurb.tsx";

interface SignUpLegalCheckboxProps {
    checked: boolean;
    setChecked: (value: boolean) => void;
    legalBlurb: ReactNode;
}

export const SignUpLegalCheckbox = ({
    checked,
    setChecked,
    legalBlurb,
}: SignUpLegalCheckboxProps) => {
    const updatedLegalBlurbFeatureFlagOn = useFlagOrCookie(
        "affirmative-action-legal-blurb",
    );
    return (
        <Checkbox
            testId="tos-checkbox"
            onChange={() => setChecked(!checked)}
            checked={checked}
            label={
                updatedLegalBlurbFeatureFlagOn ? (
                    <View style={styles.labelSpacing}>
                        <SignUpLegalCheckboxBlurb />
                    </View>
                ) : (
                    <View style={styles.labelSpacing}>{legalBlurb}</View>
                )
            }
        />
    );
};

const styles = StyleSheet.create({
    labelSpacing: {
        paddingInlineStart: sizing.size_040,
    },
});
